import { Component, EventEmitter, Injector, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BodyComponentObject, CategoryTemplateMessage, StatusTemplateMessage, TemplateMessageObject, TemplateMessageObjectPager } from '@trendbuild/trend-cloud-api';
import { AbstractComponent, Channel, ChannelService } from 'lib-trend-core';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'wa-template',
    // templateUrl: './wa-template.component.html',
    templateUrl: './wa-template.v2.component.html',
    styleUrls: ['./wa-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WaTemplateComponent extends AbstractComponent {

  selectedTemplateId: string | null = null;


  @Input() set channel(channel: Channel) {
    this.selectedChannel = channel;
    if (!channel?._id) {
      this.loadSeq++;
      this.loading = false;
      this.templates = [];
      this.allTemplates = [];
      return;
    }
    this.getList();
  }

  private loadSeq: number = 0;

  @Output() onSelectTemplate = new EventEmitter<TemplateMessageObject>();

  selectedChannel: Channel;

  templates: Array<TemplateMessageObject> = new Array<TemplateMessageObject>()

  allTemplates: TemplateMessageObject[] = [];
  searchControl: FormControl = new FormControl('');
  selectedCategory: string = '';
  selectedStatus: string = '';

  categories = [
    { value: 'MARKETING', label: this.t('attendance.waTemplate.categoryMarketing') },
    { value: 'UTILITY', label: this.t('attendance.waTemplate.categoryUtility') },
    { value: 'AUTHENTICATION', label: this.t('attendance.waTemplate.categoryAuthentication') },
  ];

  statuses = [
    { value: 'APPROVED', label: this.t('attendance.waTemplate.statusApproved') },
    { value: 'PENDING', label: this.t('attendance.waTemplate.statusPending') },
    { value: 'REJECTED', label: this.t('attendance.waTemplate.statusRejected') }
  ];

  constructor(injector: Injector, private channelService: ChannelService) {
    super(injector);
  }

  public getList() {
    if (!this.selectedChannel) return;

    this.loading = true;
    const seq = ++this.loadSeq;
    const isCurrentLoad = () => seq === this.loadSeq;

    this.channelService.getTemplatesByChannel(this.selectedChannel._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (templateMessageObjectPager: TemplateMessageObjectPager) => {
          if (!isCurrentLoad()) {
            return;
          }
          try {
            const allTemplates = templateMessageObjectPager.data || [];

            if (this.selectedTemplateId) {
              const selectedTemplate = allTemplates.find(template => template.id === this.selectedTemplateId);
              if (selectedTemplate) {
                this.templates = [selectedTemplate];
                this.allTemplates = [selectedTemplate];
              }
            } else {
              this.templates = allTemplates;
              this.allTemplates = allTemplates;
            }
            this.loading = false;
          } catch (error) {
            console.error('Error fetching templates:', error);
            this.templates = [];
            this.allTemplates = [];
          }
          this.loading = false;
        },
        error: (err) => {
          if (!isCurrentLoad()) {
            return;
          }
          this.loading = false;
          this.templates = [];
          this.allTemplates = [];
          console.error('Error fetching templates:', err);
        }
      });
  }

  public showTemplateDetails(template: TemplateMessageObject) {
    this.onSelectTemplate.emit(template)
  }

  public getBodyText(template: TemplateMessageObject): string {
    const bodyComponent = <BodyComponentObject>template?.components.find(c => c.type === 'BODY');
    return bodyComponent.text;
  }

  filterTemplates(event: any) {
    if (this.selectedTemplateId) return;
    const value = typeof event === 'string' ? event : event?.target?.value || '';
    this.applyFilters(value);
  }

  public cleanCacheTemplates() {
    this.channelService.cleanCacheTemplatesByChannel(this.selectedChannel._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.templates = [];
          this.allTemplates = [];
          this.getList();
        }
      });
  }

  filterByCategory(category: string) {
    if (this.selectedTemplateId) return;
    this.selectedCategory = category;
    this.applyFilters();
  }

  filterByStatus(status: string) {
    if (this.selectedTemplateId) return;
    this.selectedStatus = status;
    this.applyFilters();
  }

  private applyFilters(searchValue: string = this.searchControl.value) {
    let filteredTemplates = [...this.allTemplates];

    if (this.selectedCategory) {
      filteredTemplates = filteredTemplates.filter(template =>
        template.category === this.selectedCategory
      );
    }

    if (this.selectedStatus) {
      filteredTemplates = filteredTemplates.filter(template =>
        template.status === this.selectedStatus
      );
    }

    // Aplicar filtro de busca
    if (searchValue?.trim()) {
      const search = searchValue.toLowerCase();
      filteredTemplates = filteredTemplates.filter(template =>
        template.name.toLowerCase().includes(search) ||
        template.category?.toLowerCase().includes(search) ||
        (<BodyComponentObject>template.components?.find(c => c.type === 'BODY'))?.text?.toLowerCase().includes(search)
      );
    }

    this.templates = filteredTemplates;
  }

  translateTemplateStatus(status: StatusTemplateMessage | string): string {
    switch (status) {
      case 'PENDING':
        return this.t('attendance.waTemplate.statusPending');
      case 'APPROVED':
        return this.t('attendance.waTemplate.statusApproved');
      case 'REJECTED':
        return this.t('attendance.waTemplate.statusRejected');
      default:
        return '';
    }
  }

  translateTemplateCategory(type: CategoryTemplateMessage | string): string {
    switch (type) {
      case 'AUTHENTICATION':
        return this.t('attendance.waTemplate.categoryAuthentication');
      case 'MARKETING':
        return this.t('attendance.waTemplate.categoryMarketing');
      case 'UTILITY':
        return this.t('attendance.waTemplate.categoryUtility');
      default:
        return '';
    }
  }

}
